import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BillingDetails from "../BillingDetails";
import CheckoutOrderSummary from "../CheckoutOrderSummary";
import CheckoutSubscribe from "../../forms/subscribe/CheckoutSubscribe";
import { useRequest } from "../../../hooks/useRequest";
import { Skeleton } from "@mui/material";
import AddAddressModal from "../../modals/AddAddressModal";
import RadioTabs from "./RadioTabs";
import { useAppContext } from "../../../context/useAppContext";

const InformationStyle = styled.div`
  .checkout__wrapper {
    display: flex;
    gap: 36px;
    margin-top: 60px;
    .checkout__billing__wrapper {
      flex: 1;
      .checkout__billing__title,
      .checkout__shipping__title {
        color: #303030;
        font-size: 27px;
        font-weight: 600;
        line-height: 34.5px;
        margin-bottom: 32.5px;
      }
      .checkout__billing__title {
        margin-top: 30px;
      }
      .checkout__billing__details {
        margin-bottom: 15.75px;
      }
      .checkout__billing__type__title {
        font-size: 24px;
        line-height: 32px;
        font-weight: 600;
      }
    }
    .checkout__order__summary__wrapper {
      width: 445px;
    }
    .checkout__add__new__address__wrapper {
      text-align: right;
    }
    .checkout__add__new__address {
      color: #ae0000;
      font-size: 12px;
      font-weight: 600;
      display: inline-block;
      cursor: pointer;
    }
    .checkout__order__notes {
      margin-top: 54px;
      .checkout__order__notes__title {
        color: #303030;
        font-size: 15px;
        font-weight: 700;
        line-height: 22.5px;
        margin-bottom: 8.5px;
      }
      .checkout__order__notes__textarea {
        padding: 18px 24px;
        width: 100%;
        border-radius: 7.5px;
        border: 0.75px solid rgba(48, 48, 48, 0.25);
        background: #fff;
        height: 130px;
        resize: vertical;
      }
    }
  }
  .checkout__billing__type__select {
    display: flex;
    gap: 40px;
    margin: 20px 0 40px;
    .radio {
      display: flex;
      gap: 8px;
      input {
        accent-color: #ae0000;
      }
      label {
        font-size: 16px;
        line-height: 28px;
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
  @media (max-width: 768px) {
    .checkout__wrapper {
      flex-wrap: wrap;
      margin-top: 40px;
      .checkout__billing__wrapper {
        .checkout__billing__title {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 15px;
        }
      }
    }
  }
`;

const Information = ({
  handleChangeBilling,
  handleOrderNow,
  orderSummaryData,
  getShippingRateCaPost,
  caRateService,
  setCaRateService,
  checkoutAddress,
  setBillingType,
  billingType,
}) => {
  const [
    fetchAddresses,
    { isLoading: isFetchingAddresses, state: addressData },
  ] = useRequest(`/address?page=1&limit=10`);
  const [fetchSellerDetails, { isLoading: isFetchingSellerDetails }] =
    useRequest();
  const [pickupAddress, setPickupAddress] = useState([]);
  const [isAddAddress, setIsAddAddress] = useState(false);
  const [getUpdatedAddress, setGetUpdatedAddress] = useState(false);
  const [noShipping, setNoShipping] = useState(false);
  const { checkoutCartData } = useAppContext();
  // Check if all products in cart have pickup: true
  const allProductsPickup = checkoutCartData?.items?.every(item => item?.product?.pickup === true);

  // Get products that are not eligible for pickup
  const nonPickupProducts = checkoutCartData?.items?.filter(item => item?.product?.pickup !== true);

  const allProductsDeliverable = checkoutCartData?.items?.every(item => {
    const deliverable = item?.product?.deliverable;
    return deliverable === true || deliverable === undefined;
  });
  const vendorIds = React.useMemo(() => {
    if (!checkoutCartData?.items) return [];
    return [...new Set(checkoutCartData.items.map(item => item?.product?.seller))];
  }, [checkoutCartData]);
  useEffect(() => {
    fetchAddresses();
  }, [getUpdatedAddress]);


  // If billingType is pickup but not all products are pickup, change to deliver
  useEffect(() => {
    if (billingType === "pickup" && !allProductsPickup) {
      setBillingType("deliver");
    }
  }, [allProductsPickup, billingType]);

  useEffect(() => {
    const fetchSellerInfo = async (sellerId) => {
      try {
        const paths = [
          `/seller/${sellerId}/show`,
          `/seller/${sellerId}/products`,
        ];
        const results = await Promise.all(
          paths?.map((path) => fetchSellerDetails({ path }))
        );
        return results[0]?.data?.pickupAddress;
      } catch (error) {
        console.error('Error fetching seller info:', error);
        return null;
      }
    };

    const fetchAllSellerInfo = async () => {
      if (vendorIds.length > 0 && billingType === "pickup") {
        // Clear existing addresses before fetching new ones
        setPickupAddress([]);

        // Use Set to get unique vendor IDs
        const uniqueVendorIds = [...new Set(vendorIds)];

        // Fetch all seller info in parallel
        const pickupAddresses = await Promise.all(
          uniqueVendorIds.map(sellerId => fetchSellerInfo(sellerId))
        );

        // Filter out any null values and set the addresses
        setPickupAddress(pickupAddresses.filter(address => address !== null));
      }
    };

    fetchAllSellerInfo();
  }, [vendorIds, billingType]);

  const [dt, setDt] = useState(0);

  useEffect(() => {

    const fetchPrice = async(alt) => {
      const price = await getShippingRateCaPost(alt);
      if(price){
        setNoShipping(false);
      } else {
        setNoShipping(true);
      }
    }

    if (dt == 2 || dt == 3) {
      if(dt == 3){
        fetchPrice(dt)
      }else{
        fetchPrice(1)
      }
    }else{
      setNoShipping(false);
      setCaRateService(0);
    }
  }, [dt]);

  const allShippingOptions = [
    // {
    //   heading: "Bringgg",
    //   sub_heading: "Shipping fee will be updated as per regular time.",
    //   value: 0,
    // },

    {
      heading: "In-House Shipping By Seller",
      sub_heading: "It will take 30 min to update shipping fee.",
      value: 0,
    },
    {
      heading: "IB - 3rd Party Shipping",
      sub_heading: "It will take 30 mins to update shipping fee.",
      value: 1,
    },
    {
      heading: "Canada Post",
      sub_heading: "Instant shipping rates.",
      value: 2,
    },
    {
      heading: "Fedex",
      sub_heading: "Instant shipping rates.",
      value: 3,
    },
  ];

  const dts = allShippingOptions.filter(option => {
    if (allProductsDeliverable) {
      return option.value !== 1;
    }
    else {
      return option.value !== 0;
    }
  });


  return (
    <>
      <InformationStyle>
        <div className="checkout__wrapper">
          <div className="checkout__billing__wrapper">
            <h2 className="checkout__billing__type__title">Order Type</h2>
            <div className="checkout__billing__type__select">
              <div className="radio">
                <input
                  type="radio"
                  name="deliveryType"
                  checked={billingType === "deliver"}
                  value="deliver"
                  id="delivery"
                  onChange={(e) => setBillingType("deliver")}
                />
                <label for="delivery">Delivery</label>
              </div>
              <div className="radio">
                <input
                  type="radio"
                  name="deliveryType"
                  value="pickup"
                  id="pickup"
                  checked={billingType === "pickup"}
                  onChange={(e) => setBillingType("pickup")}
                  disabled={!allProductsPickup}
                />
                <label for="pickup" style={{ opacity: allProductsPickup ? 1 : 0.5 }}>Pickup</label>
              </div>
            </div>
            {!allProductsPickup && (
              <div style={{
                color: "#ae0000",
                fontSize: "14px",
                marginTop: "10px",
                padding: "10px 15px",
                backgroundColor: "#fff5f5",
                borderRadius: "5px",
                marginBottom: "40px",
                border: "1px solid #ffd7d7"
              }}>
                <p style={{ margin: "0 0 5px 0", fontWeight: "600" }}>
                  Pickup option is not available for your cart
                </p>
                <p style={{ margin: "0", fontSize: "13px" }}>
                  The following items are not eligible for pickup:
                </p>
                <ul style={{ margin: "5px 0 0 0", paddingLeft: "20px" }}>
                  {nonPickupProducts?.map((item, index) => (
                    <li key={index} style={{ marginBottom: "3px" }}>
                      {item?.product?.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {billingType !== "pickup" && ((addressData?.data?.docs?.length > 0) ? (
              <h2 className="checkout__shipping__title">Shipping Details</h2>
            ) : (
              <h2 className="checkout__shipping__title">Add New Address</h2>
            ))}

            {isFetchingAddresses && !addressData?.data?.docs && (
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={110}
                style={{ borderRadius: "10px" }}
              />
            )}
            {billingType !== "pickup" && addressData?.data?.docs?.map((address) => (
              <div
                className="checkout__billing__details"
                key={"shipping" + address?.id}
              >
                <BillingDetails
                  billingTitle={"Choose Delivery"}
                  billerName={address?.label}
                  billingAddress={address?.format}
                  billingPhone={address?.phoneNumber}
                  billingType={"delivery"}
                  billingMethod={"shipping"}
                  onClick={handleChangeBilling}
                  index={address?.id}
                  isChecked={checkoutAddress?.shipping === address?.format}
                />
              </div>
            ))}

            {billingType !== "pickup" && <div className="checkout__add__new__address__wrapper">
              <div
                className="checkout__add__new__address"
                onClick={() => setIsAddAddress(true)}
              >
                Add New Address
              </div>
            </div>}

            {/* Pickup Addresses */}
            {billingType === "pickup" && (
              <div style={{ marginTop: '20px' }}>
                {isFetchingSellerDetails ? (
                  <div style={{
                    padding: '20px',
                    textAlign: 'center',
                    background: '#f8f8f8',
                    borderRadius: '8px'
                  }}>
                    <p style={{
                      color: '#666',
                      margin: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }}>
                      <span>Loading pickup addresses...</span>
                    </p>
                  </div>
                ) : pickupAddress && pickupAddress.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {pickupAddress.map((address, index) => (
                      <div key={index} style={{
                        background: '#fff',
                        border: '1px solid #eee',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                      }}>
                        <div style={{
                          padding: '16px',
                          borderBottom: '1px solid #eee',
                          background: '#f8f8f8'
                        }}>
                          <p style={{
                            margin: 0,
                            color: '#333',
                            fontWeight: '600',
                            fontSize: '16px'
                          }}>
                            Pickup Location {index + 1}
                          </p>
                          {checkoutCartData?.items?.filter(item => item?.product?.seller === vendorIds[index])?.map((item, itemIndex) => (
                            <p key={itemIndex} style={{
                              margin: '8px 0 0 0',
                              color: '#666',
                              fontSize: '14px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <span style={{
                                display: 'inline-block',
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                background: '#666'
                              }}></span>
                              {item?.product?.name} (Qty: {item?.quantity})
                            </p>
                          ))}
                        </div>

                        <div style={{ padding: '16px' }}>
                          <div style={{ marginBottom: '16px' }}>
                            <p style={{
                              margin: '0 0 8px 0',
                              color: '#666',
                              fontSize: '14px',
                              lineHeight: '1.5'
                            }}>
                              {address.address}
                            </p>
                            <p style={{
                              margin: '0 0 8px 0',
                              color: '#666',
                              fontSize: '14px'
                            }}>
                              {address.city}, {address.province}
                            </p>
                            <p style={{
                              margin: 0,
                              color: '#666',
                              fontSize: '14px'
                            }}>
                              <span style={{ fontWeight: '600' }}>Postal Code:</span> {address.postalCode?.replace(/([A-Za-z]\d[A-Za-z])(\d[A-Za-z]\d)/, '$1 $2')}
                            </p>
                          </div>
                          <div style={{ padding: '16px' }}>
                            <p style={{
                              margin: '0 0 12px 0',
                              color: '#333',
                              fontWeight: '600',
                              fontSize: '14px'
                            }}>
                              Pickup Hours
                            </p>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                              gap: '12px'
                            }}>
                              {address.availableHours?.map((day) => (
                                <div key={day.day} style={{
                                  padding: '12px',
                                  background: '#f8f8f8',
                                  borderRadius: '6px',
                                  border: '1px solid #eee'
                                }}>
                                  <span style={{
                                    display: 'block',
                                    fontWeight: '500',
                                    textTransform: 'capitalize',
                                    marginBottom: '4px',
                                    color: '#333',
                                    fontSize: '14px'
                                  }}>
                                    {day.day}
                                  </span>
                                  <span style={{
                                    color: '#666',
                                    fontSize: '14px'
                                  }}>
                                    {day.value}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{
                    padding: '20px',
                    textAlign: 'center',
                    background: '#f8f8f8',
                    borderRadius: '8px'
                  }}>
                    <p style={{
                      color: '#666',
                      margin: 0
                    }}>
                      No pickup addresses available
                    </p>
                  </div>
                )}
              </div>
            )}

            {addressData?.data?.docs?.length > 0 && (
              <h2 className="checkout__billing__title">Billing Details</h2>
            )}
            {isFetchingAddresses && !addressData?.data?.docs && (
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={110}
                style={{ borderRadius: "10px" }}
              />
            )}
            {addressData?.data?.docs?.map((address) => (
              <div
                className="checkout__billing__details"
                key={"billing" + address?.id}
              >
                <BillingDetails
                  billingTitle={"Choose Delivery"}
                  billingMethod={"billing"}
                  billerName={address?.label}
                  billingAddress={address?.format}
                  billingPhone={address?.phoneNumber}
                  billingType={"delivery"}
                  onClick={handleChangeBilling}
                  index={address?.id}
                  isChecked={checkoutAddress?.billing === address?.format}
                />
              </div>
            ))}

            {addressData?.data?.docs.length >= 1 && (
              <div className="checkout__add__new__address__wrapper">
                <div
                  className="checkout__add__new__address"
                  onClick={() => setIsAddAddress(true)}
                >
                  Update billing information
                </div>
              </div>
            )}

            {billingType === "deliver" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: 20,
                  marginTop: 50,
                }}
              >
                <h5 style={{ fontWeight: "500" }}>
                  You have to choose an option below to delivery
                </h5>
                {dts.map((element) => (
                  <RadioTabs
                    key={element.value}
                    {...element}
                    setDT={setDt}
                    dt={dt}
                  />
                ))}
              </div>
            )}

            <div className="checkout__order__notes">
              <h3 className="checkout__order__notes__title">Order Notes</h3>
              <textarea
                className="checkout__order__notes__textarea"
                placeholder="Enter your order notes ..."
              ></textarea>
            </div>
          </div>
          <div className="checkout__order__summary__wrapper">
            <CheckoutOrderSummary
              orderSummaryData={orderSummaryData}
              checkoutAddress={checkoutAddress}
              handleOrderNow={handleOrderNow}
              caRateService={caRateService}
              dt={dt}
              billingType={billingType}
              isCheckoutDisabled={
                billingType == 'pickup' ? !checkoutAddress?.billing : (noShipping || !checkoutAddress?.shipping || !checkoutAddress?.billing)
              }
            />
          </div>
        </div>
      </InformationStyle>
      {isAddAddress && (
        <AddAddressModal
          setIsAddressModal={setIsAddAddress}
          setGetAddressUpdates={setGetUpdatedAddress}
        />
      )}
      {/* <CheckoutSubscribe /> */}
    </>
  );
};

export default Information;
